import { buildPublicCDNUrl } from "@repo/utils/lib/url";
import {
  type IImageTransformationsProvider,
  type ImageTransformationKind,
  type SupportedImageTransformationsProvider,
  TRANSFORMATION_MAP,
} from "../../../types";

export class CloudflareImagesProvider implements IImageTransformationsProvider {
  identifier: SupportedImageTransformationsProvider = "cloudflare-images";

  buildImageCDNUrl(
    key: string,
    kind: ImageTransformationKind = "original",
  ): string {
    if (kind === "original") {
      return buildPublicCDNUrl(key);
    }

    const transformation = TRANSFORMATION_MAP[kind];

    const finalKey = ["cdn-cgi", "image", transformation, key].join("/");

    return buildPublicCDNUrl(finalKey);
  }

  convertToTransformationUrl(
    current: string,
    kind: ImageTransformationKind = "original",
  ): string {
    if (kind === "original") {
      return current;
    }

    const transformation = TRANSFORMATION_MAP[kind];

    const url = new URL(current);
    const pathSegments = [
      "cdn-cgi",
      "image",
      transformation,
      ...url.pathname.slice(1).split("/"),
    ];

    url.pathname = `/${pathSegments.join("/")}`;
    return url.toString();
  }

  isTransformationUrl(url: string): boolean {
    return url.startsWith(`${buildPublicCDNUrl("cdn-cgi/image/")}`);
  }
}

export const cloudflareImagesProvider = new CloudflareImagesProvider();
